import { Controller } from "stimulus"

export default class extends Controller
  @values =
    options: Object

  initialize: ->
    $(@element).datepicker(@optionsValue)